export const usePagination = ({
  page,
  pageCount,
  boundaryCount = 1,
  siblingCount = 1
}) => {
  const startPages = range(1, Math.min(boundaryCount, pageCount));
  const endPages = range(Math.max(pageCount - boundaryCount + 1, boundaryCount + 1), pageCount);
  const siblingsStart = Math.max(Math.min(
  // Natural start
  page - siblingCount
  // Lower boundary when page is high
  // pageCount - boundaryCount - siblingCount * 2 - 1
  ),
  // Greater than startPages
  boundaryCount + 2);
  const siblingsEnd = Math.min(Math.max(
  // Natural end
  page + siblingCount
  // Upper boundary when page is low
  // boundaryCount + siblingCount * 2 + 2
  ),
  // Less than endPages
  endPages.length > 0 ? endPages[0] - 2 : pageCount - 1);
  const pages = [...startPages,
  // Start ellipsis
  ...(page > siblingsStart + siblingCount - 1 ? ['start-ellipsis'] : boundaryCount + 1 < pageCount - boundaryCount ? [boundaryCount + 1] : []),
  // Sibling pages
  ...range(siblingsStart, siblingsEnd),
  // End ellipsis
  ...(page + siblingCount + 1 < pageCount ? ['end-ellipsis'] : pageCount - boundaryCount > boundaryCount ? [pageCount - boundaryCount] : []), ...endPages];
  const pagination = [{
    type: 'first',
    page: 1,
    selected: false,
    disabled: page <= 1
  }, {
    type: 'previous',
    page: page - 1,
    selected: false,
    disabled: page <= 1
  }, ...pages.map(item => item === 'start-ellipsis' || item === 'end-ellipsis' ? {
    type: item,
    page: 0,
    selected: false,
    disabled: true
  } : {
    type: 'page',
    page: item,
    selected: item === page,
    disabled: false
  }), {
    type: 'next',
    page: page + 1,
    selected: false,
    disabled: page >= pageCount
  }, {
    type: 'last',
    page: pageCount,
    selected: false,
    disabled: page >= pageCount
  }];
  // @ts-expect-error TS(2322) FIXME: Type '({ type: any; page: number; selected: boolea... Remove this comment to see the full error message
  return pagination;
};
// @ts-expect-error TS(7006) FIXME: Parameter 'start' implicitly has an 'any' type.
const range = (start, end) => {
  const length = end - start + 1;
  return Array.from({
    length
  }, (_, index) => start + index);
};